import React, { useState } from "react";
import {
    Typography,
    ListItem, List, Grid, IconButton
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import moment from 'moment-timezone';
import { Remove, Add } from '@material-ui/icons';
import CollapseImage from "./collapse";
import classnames from 'classnames';
const useStyles = makeStyles((theme) => ({
    iconButton: {
        borderRadius: '8px',
        padding: '2px'
    },
    iconButtonOpen: {
        fontSize: '11px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#237fc2',
        backgroundColor: '#c1e5fa',
    },
    iconButtonClose: {
        fontSize: '11px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#ffffff',
        backgroundColor: '#237fc2',
        "&:hover": {
            backgroundColor: '#65a9db'
        },
    }, Text: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#4f5064',
    }
}));


export default function LogItem({ item, classes, alarmClock = false }) {
    const [expand, setExpand] = useState(false)
    const classes2 = useStyles();
    const formatTimestamp = (timestamp) => {
        if (!timestamp) {
            return '';
        }

        return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
    };
    const handleOpen = () => {
        setExpand(!expand)
    }
    const iconButtonClasses = expand ? [classes2.iconButton, classes2.iconButtonOpen] : [classes2.iconButton, classes2.iconButtonClose];

    return (
        <List style={{ paddingTop: '2px', paddingBottom: '2px' }}>

            <ListItem className={classes.root} onClick={handleOpen}  >
                <Grid container >
                    <Grid item xs={4} >
                        <Grid container >
                            <Grid style={{ alignItems: "center", marginRight: 10 }}>
                                <IconButton style={{ height: "18px" }} className={classnames(iconButtonClasses)} onClick={handleOpen}  >
                                    {expand ? <Remove fontSize='small' /> : <Add fontSize='small' />}
                                </IconButton>
                            </Grid>
                            <Grid>
                                <Typography className={classes.Text}>{formatTimestamp(alarmClock ? item.ts : item.timestamp)}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={2} >
                        <Typography className={classes.Text}>{alarmClock ? item.type : item.level}</Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.childItem} >
                        <Typography style={{ overflow: "hidden", textOverflow: "ellipsis" }} className={classes.Text}>{alarmClock ? item.ms : item.message}</Typography>
                    </Grid>
                </Grid>
            </ListItem>
            <CollapseImage width="100%" expand={expand} item={alarmClock ? item.ms : item.message} />
        </List >
    );
}

